const getWmtsTileSize = (tileSize: number[] | number): number =>
  Array.isArray(tileSize) ? tileSize[0] : tileSize;

export default getWmtsTileSize;
